module.exports = __webpack_public_path__ + "static/media/BoxPlotQ4_1.350b92a7.svg";